export default __webpack_public_path__ + "static/media/ServiceAndWarranty.438f8a37.svg";